"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Panel = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _useDebounce = require("use-debounce");
var _dialog = require("@reach/dialog");
var _Icon = require("../Icons/PetSure/Icon");
var _panelPropTypes = require("../../../propTypes/panelPropTypes");
var _hooks = require("../../../hooks");
var _interactionsHelper = require("../../../helpers/interactionsHelper");
require("./panels.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Panel = _ref => {
  let {
    fixed = true,
    type = 'sliding',
    open = false,
    position = 'right',
    size = 'main',
    // full = full screen | main = overlays main content | aside = thin panel 400px
    modalLabel = 'Dialog content',
    children,
    onClose,
    customCssClass,
    scrollContent,
    header,
    footer,
    customTrackingData,
    customTrackingEvents,
    onPanelScroll = () => {}
  } = _ref;
  const [isOpen, setIsOpen] = (0, _react.useState)(open);
  const TOGGLE_TEXT = 'Open and close panel';
  const panelToggleButton = (0, _react.useRef)(null);
  (0, _hooks.useTracking)({
    elementRef: panelToggleButton,
    trackingProps: {
      label: modalLabel,
      panelIsOpen: isOpen
    },
    customTrackingData,
    customTrackingEvents
  });
  const determineScrollSettings = (0, _useDebounce.useDebouncedCallback)(event => {
    onPanelScroll({
      scrollSettings: (0, _interactionsHelper.getScrollSettings)(event)
    });
  }, 500, {
    maxWait: 2000
  });
  const ModalCloseButton = () => {
    const modalCloseButton = (0, _react.useRef)(null);
    (0, _hooks.useTracking)({
      elementRef: modalCloseButton,
      trackingProps: {
        label: modalLabel
      },
      customTrackingData,
      customTrackingEvents
    });
    return /*#__PURE__*/_react.default.createElement("button", {
      ref: modalCloseButton,
      className: "modalClose",
      title: TOGGLE_TEXT,
      type: "button",
      onClick: () => HandleClose()
    }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: "close"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, "Close dialog"));
  };
  const HandleClose = () => {
    setIsOpen(false);
    if (onClose) {
      onClose();
    }
  };
  const HandleToggle = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    if (!newState && onClose) {
      onClose();
    }
  };
  const panelCssClass = (0, _react.useMemo)(() => "petSure_panel ".concat(fixed && type !== 'modal' ? 'fixed' : '', " petSure_").concat(type, " ").concat(customCssClass || '', " ").concat(position, " size_").concat(size, " ").concat(isOpen ? 'open' : ''), [customCssClass, fixed, isOpen, position, size, type]);
  if (type === 'modal') {
    return /*#__PURE__*/_react.default.createElement(_dialog.DialogOverlay, {
      className: "petSureDialogOverlay",
      isOpen: isOpen,
      onDismiss: HandleClose
    }, /*#__PURE__*/_react.default.createElement(_dialog.DialogContent, {
      "aria-label": modalLabel,
      className: panelCssClass,
      onScroll: scrollContent ? determineScrollSettings : null
    }, header ? /*#__PURE__*/_react.default.createElement("header", {
      className: header.fixed ? 'fixedDialogHeader' : ''
    }, typeof header.content === 'string' ? /*#__PURE__*/_react.default.createElement("h2", null, header.content) :
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    _react.default.createElement(_react.default.Fragment, null, header.content), /*#__PURE__*/_react.default.createElement(ModalCloseButton, null)) : /*#__PURE__*/_react.default.createElement(ModalCloseButton, null), /*#__PURE__*/_react.default.createElement("main", {
      onScroll: scrollContent ? determineScrollSettings : null,
      className: "panelContent ".concat(scrollContent ? 'scrollingDialogMain' : '', " ").concat(footer && footer.fixed ? 'withFixedFooter' : '')
    }, children), footer && footer.content && /*#__PURE__*/_react.default.createElement("footer", {
      className: footer.fixed ? 'fixedDialogFooter' : ''
    }, footer.content)));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: panelCssClass
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panelContent"
  }, /*#__PURE__*/_react.default.createElement("button", {
    ref: panelToggleButton,
    className: "panelToggle ".concat(type),
    title: TOGGLE_TEXT,
    type: "button",
    onClick: () => HandleToggle()
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, TOGGLE_TEXT)), isOpen ? children : null));
};
exports.Panel = Panel;
Panel.propTypes = _panelPropTypes.PanelPropTypes;
var _default = exports.default = Panel;